document.addEventListener("DOMContentLoaded", function () {
  const summaries = document.querySelectorAll("summary[data-follow-link]");

  summaries.forEach(summary => {
    // Completely remove border, text-decoration and box-shadow
    summary.style.border = "none";
    summary.style.textDecoration = "none";
    summary.style.boxShadow = "none";
    
    // Add a class to override any pseudo-element styling
    summary.classList.add("no-hover-line");
  });
});
